<template>
  <div class="room ventilation" v-loading="loadingData">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="device-block-multi">
      <div class="device-block" :class="warningFlag">
        <div class="device-block-line-chart">
          <DoubleGraph
            :opts="humidityLineOpts"
            :series="humidityLineData"
          ></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap
            :opts="humidityBarOpts"
            :series="humidityBarData"
          ></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-half">
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopL1"
            :series="switchDataTopL1"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopL2"
            :series="switchDataTopL2"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopL3"
            :series="switchDataTopL3"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopL4"
            :series="switchDataTopL4"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopL5"
            :series="switchDataTopL5"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopL6"
            :series="switchDataTopL6"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopL7"
            :series="switchDataTopL7"
          ></SwitchStatus>
        </div>
        <div class="device-block-line-item-half">
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopR1"
            :series="switchDataTopR1"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopR2"
            :series="switchDataTopR2"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopR3"
            :series="switchDataTopR3"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopR4"
            :series="switchDataTopR4"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopR5"
            :series="switchDataTopR5"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleTopR6"
            :series="switchDataTopR6"
          ></SwitchStatus>
          <RunningTime
            class="divice-block-thin"
            title="除湿机运行时间"
            :series="runningTimeData"
            :isHour="true"
          ></RunningTime>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <div class="device-block-line-item-half">
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftL1"
            :series="switchDataLeftL1"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftL2"
            :series="switchDataLeftL2"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftL3"
            :series="switchDataLeftL3"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftL4"
            :series="switchDataLeftL4"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftL5"
            :series="switchDataLeftL5"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftL6"
            :series="switchDataLeftL6"
          ></SwitchStatus>
        </div>
        <div class="device-block-line-item-half">
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftR1"
            :series="switchDataLeftR1"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftR2"
            :series="switchDataLeftR2"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftR3"
            :series="switchDataLeftR3"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftR4"
            :series="switchDataLeftR4"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftR5"
            :series="switchDataLeftR5"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleLeftR6"
            :series="switchDataLeftR6"
          ></SwitchStatus>
        </div>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-half">
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightL1"
            :series="switchDataRightL1"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightL2"
            :series="switchDataRightL2"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightL3"
            :series="switchDataRightL3"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightL4"
            :series="switchDataRightL4"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightL5"
            :series="switchDataRightL5"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightL6"
            :series="switchDataRightL6"
          ></SwitchStatus>
        </div>
        <div class="device-block-line-item-half">
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightR1"
            :series="switchDataRightR1"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightR2"
            :series="switchDataRightR2"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightR3"
            :series="switchDataRightR3"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightR4"
            :series="switchDataRightR4"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightR5"
            :series="switchDataRightR5"
          ></SwitchStatus>
          <SwitchStatus
            class="switch-item"
            :title="switchTitleRightR6"
            :series="switchDataRightR6"
          ></SwitchStatus>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configJson from './config/mainCable.json';

export default {
  name: 'ventilationNew',
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: '',
      stationName: '',
      deviceList: [],
      isHuanggang: false,

      switchTitleTopL1: '除湿机运行',
      switchTitleTopL2: '除湿机处理压差报警',
      switchTitleTopL3: '除湿机一级除湿',
      switchTitleTopL4: '除湿机设定一级',
      switchTitleTopL5: '手自动选择',
      switchTitleTopL6: '初效过滤压差报警',
      switchTitleTopL7: '高效过滤压差报警',
      switchTitleTopR1: '除湿机故障',
      switchTitleTopR2: '除湿机再生压差报警',
      switchTitleTopR3: '除湿机二级除湿',
      switchTitleTopR4: '除湿机设定二级',
      switchTitleTopR5: '手动启动',
      switchTitleTopR6: '中效过滤压差报警',

      switchTitleRightL1: '上游送风机运行',
      switchTitleRightL2: '下游送风机运行',
      switchTitleRightL3: '冷却风机运行',
      switchTitleRightL4: '压缩机运行',
      switchTitleRightL5: '冷凝风机运行',
      switchTitleRightL6: '蒸发风机运行',
      switchTitleRightR1: '上游送风机故障',
      switchTitleRightR2: '下游送风机故障',
      switchTitleRightR3: '冷却风机故障',
      switchTitleRightR4: '压缩机故障',
      switchTitleRightR5: '冷凝风机故障',
      switchTitleRightR6: '蒸发风机故障',

      switchTitleLeftL1: '压缩机高压报警',
      switchTitleLeftL2: '上游送风机开启',
      switchTitleLeftL3: '冷却风机开启',
      switchTitleLeftL4: '冷凝风机开启',
      switchTitleLeftL5: '主缆通信供电',
      switchTitleLeftL6: '系统运行',
      switchTitleLeftR1: '压缩机低压报警',
      switchTitleLeftR2: '下游送风机开启',
      switchTitleLeftR3: '压缩机开启',
      switchTitleLeftR4: '蒸发风机开启',
      switchTitleLeftR5: '除湿机控制选择',
      switchTitleLeftR6: '系统报警',

      runningTimeTitle: '除湿机运行时间',

      switchDataLeftL1: {},
      switchDataLeftL2: {},
      switchDataLeftL3: {},
      switchDataLeftL4: {},
      switchDataLeftL5: {},
      switchDataLeftL6: {},
      switchDataLeftR1: {},
      switchDataLeftR2: {},
      switchDataLeftR3: {},
      switchDataLeftR4: {},
      switchDataLeftR5: {},
      switchDataLeftR6: {},

      switchDataRightL1: {},
      switchDataRightL2: {},
      switchDataRightL3: {},
      switchDataRightL4: {},
      switchDataRightL5: {},
      switchDataRightL6: {},
      switchDataRightR1: {},
      switchDataRightR2: {},
      switchDataRightR3: {},
      switchDataRightR4: {},
      switchDataRightR5: {},
      switchDataRightR6: {},

      switchDataTopL1: {},
      switchDataTopL2: {},
      switchDataTopL3: {},
      switchDataTopL4: {},
      switchDataTopL5: {},
      switchDataTopL6: {},
      switchDataTopL7: {},
      switchDataTopR1: {},
      switchDataTopR2: {},
      switchDataTopR3: {},
      switchDataTopR4: {},
      switchDataTopR5: {},
      switchDataTopR6: {},

      runningTimeData: null,

      warningFlag: '',

      humidityLineData: null,
      humidityBarData: null,
    };
  },
  computed: {
    humidityLineOpts: function () {
      return {
        title: this.stationName + '除湿机温湿度',
        legend1: '湿度',
        legend2: '温度',
      };
    },
    humidityBarOpts: function () {
      return {
        title: '除湿机温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C',
      };
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    readConfig() {
      const routerPath = this.$route.fullPath.split('/');
      this.deviceList = configJson[routerPath[3]].deviceList;
      // const deviceName = configJson[routerPath[3]].deviceName;
      // this.deviceLeftName = deviceName.deviceLeftName;
      // this.deviceRightName = deviceName.deviceRightName;
      this.stationId = configJson[routerPath[3]].stationId;
      this.stationName = configJson[routerPath[3]].stationName;
      this.bridgeSegmentName = configJson[routerPath[3]].bridgeSegmentName;

      if(routerPath[3] === 'huanggang'){
        this.isHuanggang = true;
      } else {
        this.isHuanggang = false;
      }
    },
    resetData() {
      this.warningFlagLeft = '';
      this.warningFlagRight = '';
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || '';
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getLineChartData();

      let request = this.getCurrentData(this.stationId);
      request.then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);
        let currentData = res.data;

        this.setPieHistogramDataAndError(
          currentData,
          'humidityBarData',
          '除湿机温度',
          '除湿机湿度',
          'warningFlagLeft'
        );

        const switchIdLeftL1 = this.findDeviceId(this.switchTitleLeftL1);
        const switchIdLeftL2 = this.findDeviceId(this.switchTitleLeftL2);
        const switchIdLeftL3 = this.findDeviceId(this.switchTitleLeftL3);
        const switchIdLeftL4 = this.findDeviceId(this.switchTitleLeftL4);
        const switchIdLeftL5 = this.findDeviceId(this.switchTitleLeftL5);
        const switchIdLeftL6 = this.findDeviceId(this.switchTitleLeftL6);
        const switchIdLeftR1 = this.findDeviceId(this.switchTitleLeftR1);
        const switchIdLeftR2 = this.findDeviceId(this.switchTitleLeftR2);
        const switchIdLeftR3 = this.findDeviceId(this.switchTitleLeftR3);
        const switchIdLeftR4 = this.findDeviceId(this.switchTitleLeftR4);
        const switchIdLeftR5 = this.findDeviceId(this.switchTitleLeftR5);
        const switchIdLeftR6 = this.findDeviceId(this.switchTitleLeftR6);
        this.switchDataLeftL1 = {
          data: currentData[switchIdLeftL1].value,
          isError: currentData[switchIdLeftL1].errorLevel,
          isZh: true,
        };
        this.switchDataLeftL2 = {
          data: currentData[switchIdLeftL2].value,
          isError: currentData[switchIdLeftL2].errorLevel,
        };
        this.switchDataLeftL3 = {
          data: currentData[switchIdLeftL3].value,
          isError: currentData[switchIdLeftL3].errorLevel,
        };
        this.switchDataLeftL4 = {
          data: currentData[switchIdLeftL4].value,
          isError: currentData[switchIdLeftL4].errorLevel,
        };
        this.switchDataLeftL5 = {
          data: currentData[switchIdLeftL5].value,
          isError: currentData[switchIdLeftL5].errorLevel,
        };
        this.switchDataLeftL6 = {
          data: currentData[switchIdLeftL6].value,
          isError: currentData[switchIdLeftL6].errorLevel,
        };
        this.switchDataLeftR1 = {
          data: currentData[switchIdLeftR1].value,
          isError: currentData[switchIdLeftR1].errorLevel,
          isZh: true,
        };
        this.switchDataLeftR2 = {
          data: currentData[switchIdLeftR2].value,
          isError: currentData[switchIdLeftR2].errorLevel,
        };
        this.switchDataLeftR3 = {
          data: currentData[switchIdLeftR3].value,
          isError: currentData[switchIdLeftR3].errorLevel,
        };
        this.switchDataLeftR4 = {
          data: currentData[switchIdLeftR4].value,
          isError: currentData[switchIdLeftR4].errorLevel,
        };
        this.switchDataLeftR5 = {
          data: currentData[switchIdLeftR5].value,
          isError: currentData[switchIdLeftR5].errorLevel,
          textOff: "独立",
          textOn: "主控",
        };
        this.switchDataLeftR6 = {
          data: currentData[switchIdLeftR6].value,
          isError: currentData[switchIdLeftR6].errorLevel,
          isZh: true,
        };

        const switchIdRightL1 = this.findDeviceId(this.switchTitleRightL1);
        const switchIdRightL2 = this.findDeviceId(this.switchTitleRightL2);
        const switchIdRightL3 = this.findDeviceId(this.switchTitleRightL3);
        const switchIdRightL4 = this.findDeviceId(this.switchTitleRightL4);
        const switchIdRightL5 = this.findDeviceId(this.switchTitleRightL5);
        const switchIdRightL6 = this.findDeviceId(this.switchTitleRightL6);
        const switchIdRightR1 = this.findDeviceId(this.switchTitleRightR1);
        const switchIdRightR2 = this.findDeviceId(this.switchTitleRightR2);
        const switchIdRightR3 = this.findDeviceId(this.switchTitleRightR3);
        const switchIdRightR4 = this.findDeviceId(this.switchTitleRightR4);
        const switchIdRightR5 = this.findDeviceId(this.switchTitleRightR5);
        const switchIdRightR6 = this.findDeviceId(this.switchTitleRightR6);
        this.switchDataRightL1 = {
          data: currentData[switchIdRightL1].value,
          isError: currentData[switchIdRightL1].errorLevel,
        };
        this.switchDataRightL2 = {
          data: currentData[switchIdRightL2].value,
          isError: currentData[switchIdRightL2].errorLevel,
        };
        this.switchDataRightL3 = {
          data: currentData[switchIdRightL3].value,
          isError: currentData[switchIdRightL3].errorLevel,
          isNa: this.isHuanggang,
        };
        this.switchDataRightL4 = {
          data: currentData[switchIdRightL4].value,
          isError: currentData[switchIdRightL4].errorLevel,
        };
        this.switchDataRightL5 = {
          data: currentData[switchIdRightL5].value,
          isError: currentData[switchIdRightL5].errorLevel,
        };
        this.switchDataRightL6 = {
          data: currentData[switchIdRightL6].value,
          isError: currentData[switchIdRightL6].errorLevel,
        };
        this.switchDataRightR1 = {
          data: currentData[switchIdRightR1].value,
          isError: currentData[switchIdRightR1].errorLevel,
          isZh: true,
        };
        this.switchDataRightR2 = {
          data: currentData[switchIdRightR2].value,
          isError: currentData[switchIdRightR2].errorLevel,
          isZh: true,
        };
        this.switchDataRightR3 = {
          data: currentData[switchIdRightR3].value,
          isError: currentData[switchIdRightR3].errorLevel,
          isNa: this.isHuanggang,
          isZh: true,
        };
        this.switchDataRightR4 = {
          data: currentData[switchIdRightR4].value,
          isError: currentData[switchIdRightR4].errorLevel,
          isZh: true,
        };
        this.switchDataRightR5 = {
          data: currentData[switchIdRightR5].value,
          isError: currentData[switchIdRightR5].errorLevel,
          isZh: true,
        };
        this.switchDataRightR6 = {
          data: currentData[switchIdRightR6].value,
          isError: currentData[switchIdRightR6].errorLevel,
          isZh: true,
        };

        const switchIdTopL1 = this.findDeviceId(this.switchTitleTopL1);
        const switchIdTopL2 = this.findDeviceId(this.switchTitleTopL2);
        const switchIdTopL3 = this.findDeviceId(this.switchTitleTopL3);
        const switchIdTopL4 = this.findDeviceId(this.switchTitleTopL4);
        const switchIdTopL5 = this.findDeviceId(this.switchTitleTopL5);
        const switchIdTopL6 = this.findDeviceId(this.switchTitleTopL6);
        const switchIdTopL7 = this.findDeviceId(this.switchTitleTopL7);
        const switchIdTopR1 = this.findDeviceId(this.switchTitleTopR1);
        const switchIdTopR2 = this.findDeviceId(this.switchTitleTopR2);
        const switchIdTopR3 = this.findDeviceId(this.switchTitleTopR3);
        const switchIdTopR4 = this.findDeviceId(this.switchTitleTopR4);
        const switchIdTopR5 = this.findDeviceId(this.switchTitleTopR5);
        const switchIdTopR6 = this.findDeviceId(this.switchTitleTopR6);
        this.switchDataTopL1 = {
          data: currentData[switchIdTopL1].value,
          isError: currentData[switchIdTopL1].errorLevel,
        };
        this.switchDataTopL2 = {
          data: currentData[switchIdTopL2].value,
          isError: currentData[switchIdTopL2].errorLevel,
          isZh: true,
        };
        this.switchDataTopL3 = {
          data: currentData[switchIdTopL3].value,
          isError: currentData[switchIdTopL3].errorLevel,
        };
        this.switchDataTopL4 = {
          data: currentData[switchIdTopL4].value,
          isError: currentData[switchIdTopL4].errorLevel,
        };
        this.switchDataTopL5 = {
          data: currentData[switchIdTopL5].value,
          isError: currentData[switchIdTopL5].errorLevel,
          textOff: "自动",
          textOn: "手动",
        };
        this.switchDataTopL6 = {
          data: currentData[switchIdTopL6].value,
          isError: currentData[switchIdTopL6].errorLevel,
          isZh: true,
        };
        this.switchDataTopL7 = {
          data: currentData[switchIdTopL6].value,
          isError: currentData[switchIdTopL6].errorLevel,
          isZh: true,
        };
        this.switchDataTopR1 = {
          data: currentData[switchIdTopR1].value,
          isError: currentData[switchIdTopR1].errorLevel,
          isZh: true,
        };
        this.switchDataTopR2 = {
          data: currentData[switchIdTopR2].value,
          isError: currentData[switchIdTopR2].errorLevel,
          isZh: true,
        };
        this.switchDataTopR3 = {
          data: currentData[switchIdTopR3].value,
          isError: currentData[switchIdTopR3].errorLevel,
        };
        this.switchDataTopR4 = {
          data: currentData[switchIdTopR4].value,
          isError: currentData[switchIdTopR4].errorLevel,
        };
        this.switchDataTopR5 = {
          data: currentData[switchIdTopR5].value,
          isError: currentData[switchIdTopR5].errorLevel,
        };
        this.switchDataTopR6 = {
          data: currentData[switchIdTopR6].value,
          isError: currentData[switchIdTopR6].errorLevel,
          isZh: true,
        };

        const runningTimeId = this.findDeviceId(this.runningTimeTitle);
        this.runningTimeData = currentData[runningTimeId].value;
      });
    },

    getLineChartData() {
      let temperatureDeviceName = '除湿机温度';
      let humidityDeviceName = '除湿机湿度';

      this.$http
        .all([
          this.getStatisticsData(this.findDeviceId(temperatureDeviceName)),
          this.getStatisticsData(this.findDeviceId(humidityDeviceName)),
        ])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(
              temperaturePromise,
              humidityPromise,
              'humidityLineData',
              'warningFlagLeft'
            );
          })
        );
    },

    setPieHistogramDataAndError(
      currentData,
      echartSeriesDataName,
      temperatureName,
      humidityName,
      warningFlagName
    ) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[temperatureId].errorLevel,
        this[warningFlagName]
      );
      errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[humidityId].errorLevel,
        this[warningFlagName]
      );
      this[warningFlagName] = errorLevel;
    },

    setLineData(
      temperatureData,
      humidityData,
      echartSeriesDataName,
      warningFlagName
    ) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(
        temperatureData.data.errorLevel,
        this[warningFlagName]
      );
      errorLevel = this.getErrorLevelFromMultipleDevice(
        humidityData.data.errorLevel,
        this[warningFlagName]
      );
      this[warningFlagName] = errorLevel;
    },

    getStatisticsData(deviceId) {
      return this.$http.get(
        '/statistics/DeviceData?deviceId=' +
          deviceId +
          '&interval=BY_HOUR&insertBlankData=true'
      );
    },

    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === 'Error') {
        return 'Error';
      } else if (currentErrorLevel === 'Warning') {
        if (newErrorLevel === 'Error') {
          return 'Error';
        } else {
          return 'Warning';
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ventilation {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }

    .device-block-line-item {
      width: calc(50% - 9px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      // flex-direction: column;
      align-items: stretch;

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .switch-item {
        height: 50px;
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .divice-block-thin {
        height: 50px;
      }

      .running-time-item-left {
        height: calc(100% - 195px);
        width: 100%;
        box-sizing: border-box;
      }

      .running-time-item-right {
        height: calc(100% - 145px);
        width: 100%;
        box-sizing: border-box;
      }

      &.single-chart-item {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 9px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      // flex-direction: column;
      align-items: stretch;

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .switch-item {
        height: 60px;
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .running-time-item-left {
        height: calc(100% - 195px);
        width: 100%;
        box-sizing: border-box;
      }

      .running-time-item-right {
        height: calc(100% - 145px);
        width: 100%;
        box-sizing: border-box;
      }

      &.single-chart-item {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .air-wrap {
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    width: calc(50% - 10px);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    box-sizing: border-box;

    .air-title {
      padding: 20px 15px 10px 10px;
      font-size: 22px;
      color: #515151;
    }

    .air-chart-wrap {
      display: flex;
      height: 80%;
      flex: 1;
    }

    .air-chart {
      padding: 20px 0;
      box-sizing: border-box;
      width: 33.3333%;
    }

    .device-block-multi-item {
      width: calc((100% / 3) - 10px);
      // background-color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>
